import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-20",
  "use": "icon-icon-nav-20-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-20\"><path d=\"M512 192C335.36 192 192 335.36 192 512s143.36 320 320 320 320-143.36 320-320-143.36-320-320-320z m-32 573.76A255.616 255.616 0 0 1 256 512c0-19.84 2.56-38.72 6.72-57.28L416 608v32c0 35.2 28.8 64 64 64v61.76z m220.8-81.28A63.488 63.488 0 0 0 640 640h-32V544c0-17.6-14.4-32-32-32H384V448h64c17.6 0 32-14.4 32-32v-64h64c35.2 0 64-28.8 64-64v-13.12A256.128 256.128 0 0 1 768 512c0 66.56-25.6 127.04-67.2 172.48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-20.svg
// module id = 9QPB
// module chunks = 3